import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Input, Button } from 'reactstrap';
import { withRouter } from 'react-router-dom';

import './MemberDetail.scss';

import commonConstant from '../../common/_commonConstant';
import { randomNumber } from '../../common/_commonFunction';
import { Loading } from '../../components';
import { fetchGetCompany, fetchSearchVehicleLicensePlate, fetchCreateMembership, fetchUpdateMembership } from '../../actions';
import {
  Dropdown,
  validateNumber,
  DatePicker,
  validateIdentificationNo,
  validateVehiclePlate,
  validateTelNumber,
  Modal,
  IconVehicle,
  vehicleTypeIconName,
  vehicleLicensePlate,
  DropdownSearch,
  vehicleType,
  dateYYYYMMDD,
  validateEmail,
  tenantMemberRefNo,
  dateDDMMYYYYFormat,
} from '../../helpers';

class MemberDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'companyName': '',
      'tenantRefNo': '',
      'firstName': '',
      'lastName': '',
      'identificationNo': '',
      'phoneNo': '',
      'lineId': '',
      'email': '',
      'memberPackage': props.getMembershipPackage.data[0], // set default package value
      'memberStartDate': new Date(),
      'memberEndDate': null,
      'memberNote': '',
      'memberStatus': commonConstant.status[0],
      'errorIdentificationNo': null,
      'errorPhoneNo': null,
      'errorVehicleLicensePlate': null,
      'errorEmail': null,
      'disabledBtnCreateMember': true,
      'loading': false,
      'activeVehicleIndex': props.type === 'create-member' ? 0 : null,
      'memberVehicles': [{
        'vehicleType': null,
        'vehicleLicensePlate': '',
        'vehicleProvince': null,
        'vehicleBrand': null,
        'vehicleColor': '',
        'activeVehicleLicensePlate': false,
        'vehicleID': null,
        'vehicleStatus': commonConstant.status[0],
        'detail': {},
      }],
      'mainModal': true,
      'canChangeVehicle': true,
      'newVehicleIndex': null,
      'disabledBtnUpdateMember': true,
      'errorValue': null,
      'modal': null,
      'confirmSelectVehicleIndex': null,
      'deleteVehicleId' : [],
    };
  }

  UNSAFE_componentWillMount() {
    try {
      const { type } = this.props;

      if (type === 'view-detail') {
        this.setState({ ...this.handlePrepareMemberDetail(), 'memberVehicles': this.handlePrepareVehicleDetail() });
      }

      this.handleDisableBtn();
    } catch (error) {
      return null;
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { getCompany, createMembership, updateMembership } = this.props;

    if (nextProps.getCompany && nextProps.getCompany !== getCompany) {
      return this.setState({ 'loading': false });
    } else if (nextProps.createMembership && nextProps.createMembership !== createMembership) {
      this.setState({ 'loading': false });
      if (nextProps.createMembership.status === 200) {
        this.props.handleClearState();
        return this.props.handleSetToast('create-member');
      } else if (nextProps.createMembership.status === 400 && nextProps.createMembership.errorMessage === commonConstant.trowErrorCreateMembership) {
        return this.setState({ 'errorVehicleLicensePlate': 'duplicate' });
      }
    } else if (nextProps.updateMembership && nextProps.updateMembership !== updateMembership) {
      this.setState({ 'loading': false });
      if (nextProps.updateMembership.status === 200) {
        this.props.handleClearState();
        return this.props.handleSetToast('update-member');
      } else if (nextProps.updateMembership.status === 400 && nextProps.updateMembership.errorMessage === commonConstant.trowErrorUpdateMembership) {
        return this.setState({ 'errorVehicleLicensePlate': 'duplicate' });
      }
    }
  }

  handlePrepareMemberDetail = () => {
    const { getMembershipDetail } = this.props;
    const customer = !getMembershipDetail.customer.customerInfo.firstName && !getMembershipDetail.customer.customerInfo.lastName ? {
      ...getMembershipDetail.customer.customerInfo,
      'firstName': getMembershipDetail.customer.customerInfo.name.split(' ')[0],
      'lastName': getMembershipDetail.customer.customerInfo.name.split(' ')[1],
    } : {
      ...getMembershipDetail.customer.customerInfo,
    };

    return {
      'memberPackage': {
        ...getMembershipDetail.buildingMembershipPackage,
        'label': getMembershipDetail.buildingMembershipPackage.buildingMembershipPackageRemark,
        'value': getMembershipDetail.buildingMembershipPackage.buildingMembershipPackageID,
      },
      'companyName': {
        ...getMembershipDetail.tenant,
        'label': getMembershipDetail.tenant.tenantName,
        'value': getMembershipDetail.tenant.tenantID,
      },
      'tenantRefNo': getMembershipDetail.tenant.tenantRefNo,
      'firstName': customer.firstName || '',
      'lastName': customer.lastName || '',
      'identificationNo': customer.idCard || '',
      'phoneNo': customer.telephoneNo || '',
      'lineId': customer.lineID || '',
      'email': customer.email || '',
      'memberStartDate': new Date(getMembershipDetail.tenantMember.tenantMemberStartedAt),
      'memberEndDate': new Date(getMembershipDetail.tenantMember.tenantMemberExpiredAt),
      'memberNote': getMembershipDetail.tenantMember.tenantMemberInfo.remark || '',
      'memberStatus': getMembershipDetail.tenantMember.deletedAt ? commonConstant.status[1] : commonConstant.status[0], // NOTE. if deletedAt !== null status = inactive
    };
  }

  handlePrepareVehicleDetail = (notSetActiveVehicleIndex) => {
    try {
      const { type, getMembershipDetail } = this.props;

      if (type === 'create-member') {
        return [{
          'vehicleType': null,
          'vehicleLicensePlate': '',
          'vehicleProvince': null,
          'vehicleBrand': null,
          'vehicleColor': '',
          'activeVehicleLicensePlate': false,
          'vehicleID': null,
          'vehicleStatus': commonConstant.status[0],
          'detail': {},
        }];
      }
      let activeVehicleIndex = null;
      return getMembershipDetail.tenantMemberVehicles.map((element, index) => {
        const province = commonConstant.province.find(ele => ele.value === element.vehicleProvince) || element.vehicleProvince;

        if (
          !notSetActiveVehicleIndex &&
          (
            (!getMembershipDetail.tenantMemberBuildingMembershipPackages[index].deletedAt || getMembershipDetail.tenantMemberVehicles.length === 1) ||
            (index === (getMembershipDetail.tenantMemberVehicles.length - 1) && activeVehicleIndex === null)
          )
        ) {
          activeVehicleIndex = index;
          this.setState({ 'activeVehicleIndex': index });
        }

        return ({
          'vehicleType': commonConstant.vehicleType.find(ele => ele.value === element.vehicleType),
          'vehicleLicensePlate': element.vehicleLicensePlate,
          'vehicleProvince': province ? province : element.vehicleProvince ? element.vehicleProvince : null,
          'vehicleBrand': element.vehicleType === commonConstant.vehicleTypeMotorcycle ? element.vehicleBrand : (commonConstant.vehicleBrand.find(brand => brand.value === element.vehicleBrand) || element.vehicleBrand),
          'vehicleColor': element.vehicleColor || '',
          'activeVehicleLicensePlate': false,
          'vehicleID': element.vehicleID,
          'vehicleStatus': commonConstant.status[getMembershipDetail.tenantMemberBuildingMembershipPackages[index].deletedAt ? 1 : 0], // NOTE. deletedAt have value statue is inactive, but deletedAt = null status is active
          'detail': { ...element },
        });
      });
    } catch (error) {
      return null;
    }
  }

  handleVehicleValue = async (key, value, index, id, cb, disabled) => {
    try {
      const { type } = this.props;
      const { memberVehicles, memberStatus } = this.state;

      if (disabled) {
        return null;
      } else if (key === 'vehicleLicensePlate') {
        memberVehicles[index][key] = value;
        memberVehicles[index].activeVehicleLicensePlate = true;
        memberVehicles[index].vehicleType = null;
        memberVehicles[index].vehicleProvince = null;
        memberVehicles[index].vehicleBrand = null;
        memberVehicles[index].vehicleColor = null;
        memberVehicles[index].vehicleID = null;
        memberVehicles[index].detail = {
          'updatedAt': memberStatus.value === commonConstant.memberStatusInActive ? new Date() : null,
        };
      } else if (key === 'vehicleType') {
        memberVehicles[index][key] = value;
        memberVehicles[index].vehicleBrand = null;
      } else if ( // NOTE. type = view-detail and change vehicle status inactive -> active show modal warning
        key === 'vehicleStatus' &&
        type === 'view-detail' &&
        memberVehicles[index].vehicleStatus.value === commonConstant.vehicleStatusInActive &&
        value.value === commonConstant.vehicleStatusActive
      ) {
        this.setState({ 'modal': 'confirm-change-vehicle-status' });
      } else {
        memberVehicles[index][key] = value;
      }

      await cb();

      document.getElementById(id).focus();
    } catch (error) {
      return null;
    }
  }

  handleValidateValue = (validateValue, cb) => validateValue ? cb() : null;

  handleValue = async (key, value) => {
    try {
      await this.setState({ [key]: value });

      if (key === 'companyName' && !value.tenantID) {
        this.setState({ 'tenantRefNo': null });
      }

      return this.handleDisableBtn();
    } catch (error) {
      return null;
    }
  }

  handleDropDownValue = (key, value, ref) => {
    try {
      const { type } = this.props;
      const { memberStatus } = this.state;

      if (key === 'memberStartDate') {
        this.handleValue('memberEndDate', null);
      } else if (key === 'memberStatus') {
        if (type === 'view-detail' && memberStatus.value === commonConstant.memberStatusActive && value.value === commonConstant.memberStatusInActive) { // NOTE. change status active to inactive show modal warning
          this.setState({ 'modal': 'confirm-change-member-status-to-inactive' });
          return ref?.current.handleShowItem();
        } else if (type === 'view-detail' && memberStatus.value === commonConstant.memberStatusInActive && value.value === commonConstant.memberStatusActive) { // NOTE. change status inactive to active modal warning
          return this.setState({ 'modal': 'confirm-change-member-status-to-active' });
        }
      }

      this.handleValue(key, value);
      return ref?.current.handleShowItem();
    } catch (error) {
      return null;
    }
  }

  handleSelectVehiclePlate = async (ele, ref, index) => {
    try {
      const { memberVehicles, memberStatus } = this.state;

      ref.current.handleShowItem();

      const checkVehiclePlateIsRepeat = await memberVehicles.findIndex(vehicle => vehicle?.vehicleID === ele?.vehicleID);
      if (checkVehiclePlateIsRepeat !== -1) {
        return this.setState({ 'modal': 'confirm-select-vehicle', 'confirmSelectVehicleIndex': checkVehiclePlateIsRepeat });
      }

      memberVehicles[index].activeVehicleLicensePlate = false;
      memberVehicles[index].vehicleType = commonConstant.vehicleType.find(item => item.value === ele.vehicleType);
      memberVehicles[index].vehicleLicensePlate = ele.vehicleLicensePlate;
      memberVehicles[index].vehicleProvince = ele.vehicleProvince ? (commonConstant.province.find(item => item.label === ele.vehicleProvince) || ele.vehicleProvince) : null;
      memberVehicles[index].vehicleBrand = ele.vehicleBrand ? (commonConstant.vehicleBrand.find(item => item.label === ele.vehicleBrand) || ele.vehicleBrand) : null;
      memberVehicles[index].vehicleColor = ele.vehicleColor;
      memberVehicles[index].vehicleID = ele.vehicleID;
      memberVehicles[index].detail = {
        ...ele,
        'updatedAt': memberStatus.value === commonConstant.memberStatusInActive ? new Date() : ele.updatedAt,
      };

      this.handleDisableBtn();

      return this.setState({ memberVehicles });
    } catch (error) {
      return null;
    }
  }

  handleDropDownItems = (key, ref, itemIndex) => {
    try {
      const { getMembershipPackage, getCompany, searchVehicleLicensePlate } = this.props;
      const { companyName, memberStatus, memberPackage, memberVehicles } = this.state;

      switch (key) {
        case 'companyName':
          if (!companyName || companyName.length < 3 || !getCompany.data || getCompany.data.length === 0) {
            return null;
          }

          return getCompany.data.map((ele, index) => (
            <div
              id={`company-name-${index}`}
              className={`item${companyName.tenantName === ele.tenantName ? ' active' : ''}`}
              key={randomNumber()}
              onClick={() => {
                this.handleDropDownValue('companyName', { ...ele, 'label': ele.tenantName, 'value': ele.tenantID }, ref);
                this.handleValue('tenantRefNo', ele.tenantRefNo);
              }}
            >
              {ele.tenantName}
            </div>
          ));
        case 'vehicleTypes':
          return commonConstant.vehicleType.map((ele, index) => (
            <div
              id={`vehicle-type-${index}`}
              className={`item${vehicleType && vehicleType.value === ele.value ? ' active' : ''}`}
              key={randomNumber()}
              onClick={() => this.handleVehicleValue('vehicleType', ele, itemIndex, `vehicle-type-${index}`, () => this.handleDropDownValue('vehicleType', ele, ref))}
            >
              <span>{ele.label}</span>
            </div>
          ));
        case 'vehicleProvince':
          return commonConstant.province.map((ele, index) => (
            <div
              id={`vehicle-province-${index}`}
              className={`item${memberVehicles[itemIndex].vehicleProvince === ele.value ? ' active' : ''}`}
              key={randomNumber()}
              onClick={() => this.handleVehicleValue('vehicleProvince', ele, itemIndex, `vehicle-province-${index}`, () => this.handleDropDownValue('vehicleProvince', ele, ref))}
            >
              <span>{ele.label}</span>
            </div>
          ));
        case 'vehicleBrand':
          return commonConstant.vehicleBrand.map((ele, index) => (
            <div
              id={`vehicle-band-${index}`}
              className={`item${memberVehicles[itemIndex].vehicleBrand === ele.value ? ' active' : ''}`}
              key={randomNumber()}
              onClick={() => this.handleVehicleValue('vehicleBrand', ele, itemIndex, `vehicle-band-${index}`, () => this.handleDropDownValue('vehicleBrand', ele, ref))}
            >
              <span>{ele.label}</span>
            </div>
          ));
        case 'memberStatus':
          return commonConstant.status.map((ele, index) => (
            <div
              id={`member-status-${index}`}
              className={`item${memberStatus && memberStatus.value === ele.value ? ' active' : ''}`}
              key={randomNumber()}
              onClick={() => this.handleDropDownValue('memberStatus', ele, ref)}
            >
              <span>{ele.label}</span>
            </div>
          ));
        case 'vehicleStatus':
          return commonConstant.status.map((ele, index) => (
            <div
              id={`vehicle-status-${index}`}
              className={`item${memberVehicles[itemIndex].vehicleStatus && memberVehicles[itemIndex].vehicleStatus.value === ele.value ? ' active' : ''}`}
              key={randomNumber()}
              onClick={() => this.handleVehicleValue('vehicleStatus', ele, itemIndex, `vehicle-status-${index}`, () => this.handleDropDownValue('vehicleStatus', ele, ref))}
            >
              <span>{ele.label}</span>
            </div>
          ));
        case 'vehicleLicensePlate':
          if (!memberVehicles[itemIndex].vehicleLicensePlate || memberVehicles[itemIndex].vehicleLicensePlate.length < 3 || !searchVehicleLicensePlate.data || searchVehicleLicensePlate.data.length === 0) {
            return null;
          }

          return searchVehicleLicensePlate.data.map((ele, index) => (
            <div
              id={`vehicle-license-plate-${index}`}
              className={`item${memberVehicles[itemIndex]?.vehicleID === ele.vehicleID ? ' active' : ''}`}
              key={randomNumber()}
              onClick={() => this.handleSelectVehiclePlate(ele, ref, itemIndex)}
            >
              <span className="flex">
                <span>{ele.vehicleLicensePlate}</span>
                <span>{ele.vehicleProvince}</span>
                <IconVehicle className="icon" name={vehicleTypeIconName(vehicleType(ele))} />
              </span>
            </div>
          ));
        case 'memberPackage':
          return getMembershipPackage.data.map((ele, index) => (
            <div
              id={`membership-package-${index}`}
              className={`item${memberPackage && memberPackage.buildingMembershipPackageName === ele.buildingMembershipPackageName ? ' active' : ''}`}
              key={randomNumber()}
              onClick={() => this.handleDropDownValue('memberPackage', { ...ele, 'label': ele.buildingMembershipPackageRemark, 'value': ele.buildingMembershipPackageID }, ref)}
            >
              <span>{ele.buildingMembershipPackageName}</span>
            </div>
          ));
        default:
          return null;
      }
    } catch (error) {
      return null;
    }
  }

  handleValidateTemplate = (key, checkValidate) => {
    try {
      const { memberVehicles, memberStatus } = this.state;
      let checkVehiclePlate = false;
      let checkDetailVehicle = false;
      let dontHaveVehicleActive = true;

      switch (key) {
        case 'identificationNo':
          if (!this.state[key]) {
            return false;
          } else if (checkValidate) {
            return !validateIdentificationNo(this.state[key]);
          }

          this.setState({ 'errorIdentificationNo': !validateIdentificationNo(this.state[key]) ? 'template' : null });
          return true;
        case 'vehicleLicensePlate':
          memberVehicles.some(item => {
            if (item.vehicleLicensePlate && !validateVehiclePlate(item.vehicleLicensePlate)) {
              checkVehiclePlate = true;
              return true;
            }
            return false;
          });

          this.setState({ 'errorVehicleLicensePlate': checkVehiclePlate ? 'template' : null });
          return checkVehiclePlate;
        case 'phoneNo':
          if (!this.state[key]) {
            return false;
          } else if (checkValidate) {
            return !validateTelNumber(this.state[key]);
          }

          this.setState({ 'errorPhoneNo': !validateTelNumber(this.state[key]) ? 'template' : null });
          return true;
        case 'vehicleDetail':
          memberVehicles.some(item => {
            if (item.vehicleStatus.value === commonConstant.status[0].value) {
              dontHaveVehicleActive = false;
            }
            if (!item.vehicleLicensePlate || !item.vehicleType || !item.vehicleProvince || !item.vehicleStatus) {
              checkDetailVehicle = true;
              return true;
            }
            return false;
          });

          if (dontHaveVehicleActive && memberStatus.value === commonConstant.memberStatusActive) {
            this.setState({ 'errorValue': 'dont-have-vehicle-active' });
            return true;
          } else {
            this.setState({ 'errorValue': null });
          }

          return checkDetailVehicle;
        case 'email':
          if (!this.state[key]) {
            return false;
          } else if (checkValidate) {
            return !validateEmail(this.state[key]);
          }

          this.setState({ 'errorEmail': !validateEmail(this.state[key]) });
          return true;
        default:
          return false;
      }
    } catch (error) {
      return null;
    }
  }

  handleDisableBtn = () => {
    try {
      const { type } = this.props;
      const {
        companyName,
        tenantRefNo,
        firstName,
        lastName,
        phoneNo,
        memberPackage,
        memberStartDate,
        memberEndDate,
        memberNote,
        memberStatus,
      } = this.state;

      const checkTemplateIdentificationNo = this.handleValidateTemplate('identificationNo', true);
      const checkTemplatePhoneNo = this.handleValidateTemplate('phoneNo', true);
      const checkTemplateVehicleLicensePlate = this.handleValidateTemplate('vehicleLicensePlate', true);
      const checkVehicleDetail = memberStatus.value === commonConstant.memberStatusInActive ? false : this.handleValidateTemplate('vehicleDetail', true);
      const checkValidateEmail = this.handleValidateTemplate('email', true);

      if ( // check required fill
        !companyName ||
        !tenantRefNo ||
        !firstName ||
        !lastName ||
        !phoneNo ||
        !memberStartDate ||
        !memberEndDate ||
        !memberPackage ||
        !memberStatus ||
        !memberNote
      ) {
        if (type === 'view-detail') {
          return this.setState({ 'disabledBtnUpdateMember': true });
        }
        return this.setState({ 'disabledBtnCreateMember': true });
      } else if (checkTemplateIdentificationNo || checkTemplatePhoneNo || checkTemplateVehicleLicensePlate || checkVehicleDetail || checkValidateEmail) { // check error template
        if (type === 'view-detail') {
          return this.setState({ 'disabledBtnUpdateMember': true });
        }
        return this.setState({ 'disabledBtnCreateMember': true });
      }

      return this.setState({ 'disabledBtnCreateMember': false, 'disabledBtnUpdateMember': false, 'errorValue': null });
    } catch (error) {
      return null;
    }
  }

  handlePrePareVehicleDataToAPI = (vehicles) => {
    try {
      return vehicles.map(ele => ({
        'vehicleBrand': ele.vehicleBrand ? ele.vehicleBrand.value ? ele.vehicleBrand.value : ele.vehicleBrand : null,
        'vehicleColor': ele.vehicleColor ? ele.vehicleColor : null,
        'vehicleID': ele.detail.vehicleID ? ele.detail.vehicleID : null,
        'vehicleLicensePlate': ele.vehicleLicensePlate,
        'vehicleProvince': ele.vehicleProvince ? ele.vehicleProvince.value ? ele.vehicleProvince.value : ele.vehicleProvince : null,
        'vehicleStatus': ele.vehicleStatus.value,
        'vehicleType': ele.vehicleType.value,
      }));
    } catch (error) {
      return null;
    }
  }

  handlePrepareDeleteVehicleDataToAPI = (deleteVehicleId, tenantMemberId) => {    
    try {
      return deleteVehicleId.map(ele => ({
        'tenantMemberID': tenantMemberId,
        'vehicleID' : ele,
      }));
    } catch (error) {
      return null;
    }
  }

  handleCreateMember = () => {
    try {
      const { match } = this.props;
      const {
        memberVehicles,
        memberPackage,
        companyName,
        email,
        memberStartDate,
        memberEndDate,
        memberStatus,
        lineId,
        phoneNo,
        firstName,
        lastName,
        identificationNo,
        memberNote,
        disabledBtnCreateMember,
      } = this.state;

      if (disabledBtnCreateMember) {
        return null;
      }

      this.setState({ 'loading': true });
      return this.props.dispatch(fetchCreateMembership({
        'buildingID': match.params.buildingID,
        'buildingMembershipPackageID': memberPackage.buildingMembershipPackageID,
        'tenantID': companyName.tenantID,
        'tenantMemberEmail': email ? email : null,
        'tenantMemberExpiredAt': dateYYYYMMDD(memberEndDate),
        'tenantMemberFirstName': firstName,
        'tenantMemberIDCard': identificationNo ? identificationNo : null,
        'tenantMemberLastName': lastName,
        'tenantMemberLineID': lineId ? lineId : null,
        'tenantMemberMembershipStatus': memberStatus.value,
        'tenantMemberRemark': memberNote,
        'tenantMemberStartedAt': dateYYYYMMDD(memberStartDate),
        'tenantMemberTelephoneNo': phoneNo,
        'tenantMemberVehicles': this.handlePrePareVehicleDataToAPI(memberVehicles),
      }));
    } catch (error) {
      return null;
    }
  }

  handleShowModal = (checkCondition, forceClose) => {
    try {
      const { type } = this.props;

      if (type === 'create-member') {
        return this.props.handleCloseDetail();
      } else if (forceClose) {
        this.setState({
          'modal': null,
          'activeVehicleIndex': null,
          'mainModal': false,
        });
        return this.props.handleCloseDetail();
      } else if (!checkCondition) {
        return this.setState({ 'modal': null });
      } else if (checkCondition) {
        if (type === 'view-detail') {
          if (this.handleCheckChangeDetail()) { // compare data is not match
            return this.setState({ 'modal': 'confirm-cancel' });
          }

          return this.props.handleCloseDetail();
        }
        return this.setState({
          'modal': null,
          'activeVehicleIndex': null,
          'mainModal': false,
        });
      }

      return null;
    } catch (error) {
      return null;
    }
  }

  handleCheckChangeDetail = () => {
    try {
      const {
        memberPackage,
        companyName,
        tenantRefNo,
        firstName,
        lastName,
        identificationNo,
        phoneNo,
        lineId,
        email,
        memberStartDate,
        memberEndDate,
        memberNote,
        memberStatus,
        memberVehicles,
      } = this.state;
      const inputValue = {
        memberPackage,
        companyName,
        tenantRefNo,
        firstName,
        lastName,
        identificationNo,
        phoneNo,
        lineId,
        email,
        memberStartDate,
        memberEndDate,
        memberNote,
        memberStatus,
      };

      if ((JSON.stringify(inputValue) !== JSON.stringify(this.handlePrepareMemberDetail())) || (JSON.stringify(memberVehicles) !== JSON.stringify(this.handlePrepareVehicleDetail(true)))) { // compare data is not match
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  }

  handleSetItemsSearch = items => {
    if (items) {
      return items.map(ele => ({
        ...ele,
        'label': `${ele.buildingRefNo} ${ele.buildingName}`,
        'value': ele.buildingRefNo,
      }));
    }
    return null;
  }

  handleSearch = (condition, cbSetState, cbCallAPI) => {
    try {
      if (condition) {
        cbCallAPI();
      }

      return cbSetState();
    } catch (error) {
      return null;
    }
  }

  handleGetCompany = companyName => {
    this.setState({ 'loading': true });
    return this.props.dispatch(fetchGetCompany(this.props.match.params.buildingID, companyName));
  }

  handleMemberDetail = (subTitle, index, obj) => {
    try {
      const { type } = this.props;
      const { companyName, tenantRefNo, firstName, lastName, identificationNo, phoneNo, lineId, errorIdentificationNo, errorPhoneNo, email, errorEmail } = this.state;
      const company = obj ? obj.companyName : companyName,
            tenant = obj ? obj.tenantRefNo : tenantRefNo,
            first = obj ? obj.firstName : firstName,
            last = obj ? obj.lastName : lastName,
            id = obj ? obj.identificationNo : identificationNo,
            line = obj ? obj.lineId : lineId,
            phone = obj ? obj.phoneNo : phoneNo,
            mail = obj ? obj.email : email;
      this[`companyName${index !== undefined ? index : ''}`] = createRef();

      return (
        <>
          <div className={`${subTitle ? 'sub-title' : 'title'}`}>ข้อมูลสมาชิก</div>
          <div className="row-items">
            <div className="item">
              <div className="label">ชื่อบริษัท<span className="red-star"> *</span></div>
              <DropdownSearch
                id={`company-name${index !== undefined ? `-${index}` : ''}`}
                ref={this[`companyName${index !== undefined ? index : ''}`]}
                template="d"
                value={company ? company?.label ? company?.label : company : ''}
                icon="fas fa-chevron-down"
                placeholder="กรุณาเลือกบริษัท"
                onChange={event => (
                  this.handleSearch(
                    event.target.value.length >= 3 ? true : false,
                    this.handleValue('companyName', event.target.value),
                    () => this.handleGetCompany(event.target.value),
                  )
                )}
                items={this.handleDropDownItems('companyName', this[`companyName${index !== undefined ? index : ''}`], index)}
                alignIconRight
                disabled={type === 'view-detail'}
                error={type === 'view-detail' && !company && !company?.label ? true : false}
              />
              <div className="text-error">
                {type === 'view-detail' && !company && !company?.label ? '*กรุณากรอกข้อมูล' : null}
              </div>
            </div>
            <div className="item">
              <div className="label">Tenant ref. no.<span className="red-star"> *</span></div>
              <Input
                id={`tenant-ref-no${index !== undefined ? `-${index}` : ''}`}
                className={`template-d${type === 'view-detail' && !tenant ? ' error' : ''}`}
                placeholder="Tenant ref. no."
                value={tenant ? tenant : ''}
                disabled
              />
              <div className="text-error">
                {type === 'view-detail' && !tenant ? '*กรุณากรอกข้อมูล' : null}
              </div>
            </div>
          </div>
          <div className="row-items">
            <div className="item">
              <div className="label">ชื่อ<span className="red-star"> *</span></div>
              <Input
                id={`first-name${index !== undefined ? `-${index}` : ''}`}
                className={`template-d${type === 'view-detail' && !first ? ' error' : ''}`}
                placeholder="ชื่อ"
                value={first ? first : ''}
                onChange={event => this.handleValue('firstName', event.target.value)}
              />
              <div className="text-error">
                {type === 'view-detail' && !first ? '*กรุณากรอกข้อมูล' : null}
              </div>
            </div>
            <div className="item">
              <div className="label">นามสกุล<span className="red-star"> *</span></div>
              <Input
                id={`last-name${index !== undefined ? `-${index}` : ''}`}
                className={`template-d${type === 'view-detail' && !last ? ' error' : ''}`}
                placeholder="นามสกุล"
                value={last ? last : ''}
                onChange={event => this.handleValue('lastName', event.target.value)}
              />
              <div className="text-error">
                {type === 'view-detail' && !last ? '*กรุณากรอกข้อมูล' : null}
              </div>
            </div>
          </div>
          <div className="row-items">
            <div className="item">
              <div className="label">เลขประจำตัวประชาชน (Optional)</div>
              <Input
                id={`identification-no${index !== undefined ? `-${index}` : ''}`}
                className={`template-d${errorIdentificationNo ? ' error' : ''}`}
                placeholder="เลขประจำตัวประชาชน"
                value={id ? id : ''}
                onChange={event => this.handleValidateValue(validateNumber(event.target.value), () => this.handleValue('identificationNo', event.target.value))}
                onBlur={() => this.handleValidateTemplate('identificationNo')}
                maxLength="13"
              />
              <div className="text-error">
                {errorIdentificationNo ? errorIdentificationNo === 'template' ? 'เลขประจำตัวประชาชนไม่ถูกต้อง' : errorIdentificationNo === 'duplicate' ? 'พบเลขประจำตัวประชาชนซ้ำในระบบ' : null : null}
              </div>
            </div>
            <div className="item">
              <div className="label">เบอร์โทรศัพท์<span className="red-star"> *</span></div>
              <Input
                id={`phone-no${index !== undefined ? `-${index}` : ''}`}
                className={`template-d${errorPhoneNo || (type === 'view-detail' && !phone) ? ' error' : ''}`}
                placeholder="เบอร์โทรศัพท์"
                value={phone ? phone : ''}
                onChange={event => this.handleValidateValue(validateNumber(event.target.value), () => this.handleValue('phoneNo', event.target.value))}
                onBlur={() => this.handleValidateTemplate('phoneNo')}
                maxLength="10"
              />
              <div className="text-error">
                {(errorPhoneNo && errorPhoneNo === 'template' ? 'เบอร์โทรศัพท์ไม่ถูกต้อง' : null) || (type === 'view-detail' && !phone && '*กรุณากรอกข้อมูล')}
              </div>
            </div>
          </div>
          <div className="row-items">
            <div className="item">
              <div className="label">LINE ID (Optional)</div>
              <Input
                id={`line-id${index !== undefined ? `-${index}` : ''}`}
                className="template-d"
                placeholder="LINE ID"
                value={line ? line : ''}
                onChange={event => this.handleValue('lineId', event.target.value)}
              />
            </div>
            <div className="item">
              <div className="label">Email (Optional)</div>
              <Input
                id={`Email${index !== undefined ? `-${index}` : ''}`}
                className={`template-d${errorEmail ? ' error' : ''}`}
                placeholder="Email"
                value={mail ? mail : ''}
                onChange={event => this.handleValue('email', event.target.value)}
                onBlur={() => this.handleValidateTemplate('email')}
              />
              <div className="text-error">
                {errorEmail ? 'อีเมลไม่ถูกต้อง' : null}
              </div>
            </div>
          </div>
        </>
      );
    } catch (error) {
      return null;
    }
  }

  handelDeleteVehicle = (vehicleId) => {
    const { deleteVehicleId } = this.state;
    this.handleDisableBtn();
    this.setState({
      'deleteVehicleId' : [...deleteVehicleId, vehicleId],
    });
  }

  handleVehicleDetail = (index, obj) => {
    try {
      const { type } = this.props;      
      const { errorVehicleLicensePlate, memberVehicles, newVehicleIndex, memberStatus } = this.state;
      const vType = obj ? obj.vehicleType : null,
            vPlate = obj ? obj.vehicleLicensePlate : vehicleLicensePlate,
            prov = obj ? obj.vehicleProvince : null,
            brand = obj ? obj.vehicleBrand : null,
            color = obj ? obj.vehicleColor : null,
            activeVehicleLicensePlate = obj ? obj.activeVehicleLicensePlate : false,
            id = obj ? obj.vehicleID : false,
            status = obj ? obj.vehicleStatus : null;
      const disabledVehiclePlate = (type === 'view-detail' && index !== newVehicleIndex) || memberStatus.value === commonConstant.memberStatusInActive ? true : false;
      const disabledVehicleType = id || !vPlate || memberStatus.value === commonConstant.memberStatusInActive ? true : false;
      const disabledProvince = (id && obj.detail.vehicleProvince) || memberStatus.value === commonConstant.memberStatusInActive ? true : false;
      const disabledVehicleBrandAndColor = (id && type === 'view-detail' && index === newVehicleIndex) || (id && type === 'create-member') || !vType || !vPlate || memberStatus.value === commonConstant.memberStatusInActive ? true : false;
      const disabledVehicleStatus = type === 'create-member' || memberStatus.value === commonConstant.memberStatusInActive ? true : false;

      this[`vehicleTypes${index !== undefined ? index : ''}`] = createRef();
      this[`vehicleProvince${index !== undefined ? index : ''}`] = createRef();
      this[`vehicleBrand${index !== undefined ? index : ''}`] = createRef();
      this[`vehicleLicensePlate${index !== undefined ? index : ''}`] = createRef();
      this[`vehicleStatus${index !== undefined ? index : ''}`] = createRef();

      return (
        <>
          <div className="row-items">
            <div className="item">
              <div className="label">ป้ายทะเบียนรถ<span className="red-star"> *</span></div>
              <DropdownSearch
                id={`vehicle-plate${index !== undefined ? `-${index}` : ''}`}
                ref={this[`vehicleLicensePlate${index !== undefined ? index : ''}`]}
                className="template-d"
                handleClickOutSide={() => memberVehicles[index].activeVehicleLicensePlate = false}
                template="d"
                value={vPlate ? vPlate?.label ? vPlate?.label : vPlate : ''}
                icon="fas fa-chevron-down"
                placeholder="ป้ายทะเบียนรถ"
                onChange={event => (
                  !validateVehiclePlate(event.target.value) ?
                    null
                    : this.handleSearch(
                      event.target.value.length >= 3 ? true : false,
                      this.handleVehicleValue('vehicleLicensePlate', event.target.value, index, `vehicle-plate${index !== undefined ? `-${index}` : ''}`, () => this.handleValue('vehicleLicensePlate', event.target.value)),
                      () => this.props.dispatch(fetchSearchVehicleLicensePlate(event.target.value)),
                    )
                )}
                items={this.handleDropDownItems('vehicleLicensePlate', this[`vehicleLicensePlate${index !== undefined ? index : ''}`], index)}
                alignIconRight
                showDropDown={activeVehicleLicensePlate}
                error={errorVehicleLicensePlate || (type === 'view-detail' && memberStatus?.value === commonConstant.memberStatusActive && !vPlate && !vPlate?.label && newVehicleIndex !== index) ? true : false}
                disabled={disabledVehiclePlate}
              />
              <div className="text-error">
                {(errorVehicleLicensePlate === 'duplicate' && 'พบป้ายทะเบียนรถซ้ำในระบบ') || (type === 'view-detail' && memberStatus?.value === commonConstant.memberStatusActive && !vPlate && !vPlate?.label && newVehicleIndex !== index && '*กรุณากรอกข้อมูล')}
              </div>
            </div>
            <div className="item">
              <div className="label">ประเภทรถ<span className="red-star"> *</span></div>
              <Dropdown
                id={`vehicle-types${index !== undefined ? `-${index}` : ''}`}
                template="b"
                placeholder="กรุณาเลือกประเภทรถ"
                value={vType ? vType?.label : null}
                ref={this[`vehicleTypes${index !== undefined ? index : ''}`]}
                disabled={disabledVehicleType}
                error={type === 'view-detail' && memberStatus?.value === commonConstant.memberStatusActive && !vType && !vType?.label && newVehicleIndex !== index ? true : false}
              >
                {this.handleDropDownItems('vehicleTypes', this[`vehicleTypes${index !== undefined ? index : ''}`], index)}
              </Dropdown>
              <div className="text-error">
                {type === 'view-detail' && memberStatus?.value === commonConstant.memberStatusActive && !vType && !vType?.label && newVehicleIndex !== index ? '*กรุณากรอกข้อมูล' : null}
              </div>
            </div>
          </div>
          <div className="row-items">
            <div className="item">
              <div className="label">จังหวัด<span className="red-star"> *</span></div>
              <Dropdown
                className="province"
                id={`vehicle-province${index !== undefined ? `-${index}` : ''}`}
                template="b"
                placeholder="กรุณาเลือกจังหวัด"
                value={prov ? prov?.label ? prov?.label : prov : null}
                ref={this[`vehicleProvince${index !== undefined ? index : ''}`]}
                disabled={disabledProvince}
                error={type === 'view-detail' && memberStatus?.value === commonConstant.memberStatusActive && !prov && !prov?.label && newVehicleIndex !== index ? true : false}
              >
                {this.handleDropDownItems('vehicleProvince', this[`vehicleProvince${index !== undefined ? index : ''}`], index)}
              </Dropdown>
              <div className="text-error">
                {type === 'view-detail' && memberStatus?.value === commonConstant.memberStatusActive && !prov && !prov?.label && newVehicleIndex !== index ? '*กรุณากรอกข้อมูล' : null}
              </div>
            </div>
            <div className="item">
              <div className="label">ยี่ห้อรถ (Optional)</div>
              {
                vType && vType?.value === commonConstant.vehicleTypeMotorcycle ?
                  <Input
                    id={`vehicle-brand${index !== undefined ? `-${index}` : ''}`}
                    className="template-d"
                    placeholder="ยี่ห้อรถ"
                    value={brand ? brand : ''}
                    onChange={event => this.handleVehicleValue('vehicleBrand', event.target.value, index, `vehicle-brand${index !== undefined ? `-${index}` : ''}`, this.handleValue, disabledVehicleBrandAndColor)}
                    disabled={disabledVehicleBrandAndColor}
                  />
                  : <Dropdown
                    className="vehicle-brand"
                    id={`vehicle-band${index !== undefined ? `-${index}` : ''}`}
                    template="b"
                    placeholder="กรุณาเลือกยี่ห้อ"
                    value={brand ? brand?.label : null}
                    ref={this[`vehicleBrand${index !== undefined ? index : ''}`]}
                    disabled={disabledVehicleBrandAndColor}
                  >
                    {this.handleDropDownItems('vehicleBrand', this[`vehicleBrand${index !== undefined ? index : ''}`], index)}
                  </Dropdown>
              }
            </div>
          </div>
          <div className="row-items">
            <div className="item">
              <div className="label">สีรถ (Optional)</div>
              <Input
                id={`vehicle-color${index !== undefined ? `-${index}` : ''}`}
                className="template-d"
                placeholder="สีรถ"
                value={color ? color : ''}
                onChange={event => this.handleVehicleValue('vehicleColor', event.target.value, index, `vehicle-color${index !== undefined ? `-${index}` : ''}`, this.handleValue, disabledVehicleBrandAndColor)}
                disabled={disabledVehicleBrandAndColor}
              />
            </div>
            {
              type === 'view-detail' && (
                <div className="item">
                  <div className="label">สถานะรถ<span className="red-star"> *</span></div>
                  <Dropdown
                    id={`vehicle-status${index !== undefined ? `-${index}` : ''}`}
                    template="b"
                    placeholder="กรุณาเลือกสถานะ"
                    value={status ? status?.label : null}
                    ref={this[`vehicleStatus${index !== undefined ? index : ''}`]}
                    disabled={disabledVehicleStatus}
                    error={type === 'view-detail' && memberStatus?.value === commonConstant.memberStatusActive && !status && !status?.label && newVehicleIndex !== index ? true : false}
                  >
                    {this.handleDropDownItems('vehicleStatus', this[`vehicleStatus${index !== undefined ? index : ''}`], index)}
                  </Dropdown>
                  <div className="text-error">
                    {type === 'view-detail' && memberStatus?.value === commonConstant.memberStatusActive && !status && !status?.label && newVehicleIndex !== index ? '*กรุณากรอกข้อมูล' : null}
                  </div>
                </div>
              )
            }
            {
              type === 'view-detail' && index !== newVehicleIndex ? (
                <div className="delete-vehicle" onClick={() => this.handelDeleteVehicle(id)}>ลบรถคันนี้</div>
              ) : null
            }
          </div>
        </>
      );
    } catch (error) {
      return null;
    }
  }

  handleMembershipDetail = (subTitle, index, obj) => {
    try {
      const { type } = this.props;
      const { memberPackage, memberStartDate, memberEndDate, memberNote, memberStatus } = this.state;
      const startDate = obj ? obj.memberStartDate : memberStartDate,
            endDate = obj ? obj.memberEndDate : memberEndDate,
            note = obj ? obj.memberNote : memberNote,
            status = obj ? obj.memberStatus : memberStatus,
            pack = obj ? obj.memberPackage : memberPackage;
      this[`memberStartDate${index !== undefined ? index : ''}`] = createRef();
      this[`memberEndDate${index !== undefined ? index : ''}`] = createRef();
      this[`memberStatus${index !== undefined ? index : ''}`] = createRef();

      return (
        <>
          <div className={`${subTitle ? 'sub-title' : 'title'}`}>รายละเอียดสมาชิก</div>
          <div className="row-items">
            <div className="item">
              <div className="label">แพ็กแกจสมาชิก<span className="red-star"> *</span></div>
              <Dropdown
                id={`member-package${index !== undefined ? `-${index}` : ''}`}
                template="b"
                placeholder="แพ็กแกจสมาชิก"
                value={pack ? pack?.buildingMembershipPackageName : ''}
                ref={this[`memberPackage${index !== undefined ? index : ''}`]}
                error={type === 'view-detail' && !pack && !pack?.buildingMembershipPackageName ? true : false}
              >
                {this.handleDropDownItems('memberPackage', this[`memberPackage${index !== undefined ? index : ''}`])}
              </Dropdown>
              <div className="text-error">
                {type === 'view-detail' && !pack && !pack?.buildingMembershipPackageName ? '*กรุณากรอกข้อมูล' : null}
              </div>
            </div>
            <div className="item">
              <div className="label">Member Note.<span className="red-star"> *</span></div>
              <Input
                id={`member-note${index !== undefined ? `-${index}` : ''}`}
                className={`template-d${type === 'view-detail' && !note ? ' error' : ''}`}
                placeholder="Member Note."
                value={note ? note : ''}
                onChange={event => this.handleValue('memberNote', event.target.value)}
              />
              <div className="text-error">
                {type === 'view-detail' && !note ? '*กรุณากรอกข้อมูล' : null}
              </div>
            </div>
          </div>
          <div className="row-items">
            <div className="item">
              <div className="label">สมาชิกเริ่มต้น<span className="red-star"> *</span></div>
              <DatePicker
                className={`${type === 'view-detail' && !startDate ? ' border-error' : ''}`}
                id={`member-start-date${index !== undefined ? `-${index}` : ''}`}
                template="a"
                placeholder="ระบุวันที่"
                value={startDate}
                handleSelectDate={value => this.handleDropDownValue('memberStartDate', value, this[`memberStartDate${index !== undefined ? index : ''}`])}
                ref={this[`memberStartDate${index !== undefined ? index : ''}`]}
                disabled={type === 'view-detail'}
              />
              <div className="text-error">
                {type === 'view-detail' && !startDate ? '*กรุณากรอกข้อมูล' : null}
              </div>
            </div>
            <div className="item">
              <div className="label">สมาชิกสิ้นสุด<span className="red-star"> *</span></div>
              <DatePicker
                className={`${type === 'view-detail' && !endDate ? ' border-error' : ''}`}
                id={`member-end-date${index !== undefined ? `-${index}` : ''}`}
                template="a"
                placeholder="ระบุวันที่"
                value={endDate}
                handleSelectDate={value => this.handleDropDownValue('memberEndDate', value, this[`memberEndDate${index !== undefined ? index : ''}`])}
                ref={this[`memberEndDate${index !== undefined ? index : ''}`]}
                disabledDays={[{ // NOTE. if type is create-member expired date >= T+1 (tomorrow), else type is view-detail member status is active expired date >= today
                  'before': (
                    type === 'view-detail' && memberStartDate !== new Date().getTime() && memberStatus.value === commonConstant.memberStatusActive ?
                      new Date()
                      : new Date(new Date(memberStartDate).setDate(new Date(memberStartDate).getDate() + 1))
                  ),
                }]}
              />
              <div className="text-error">
                {type === 'view-detail' && !endDate ? '*กรุณาเลือกวันที่สมาชิกสิ้นสุด' : null}
              </div>
            </div>
          </div>
          {
            type === 'view-detail' && (
              <div className="row-items">
                <div className="item">
                  <div className="label">สถานะ<span className="red-star"> *</span></div>
                  <Dropdown
                    id={`member-status${index !== undefined ? `-${index}` : ''}`}
                    template="b"
                    placeholder="กรุณาเลือกสถานะ"
                    value={status ? status?.label : null}
                    ref={this[`memberStatus${index !== undefined ? index : ''}`]}
                    disabled={type === 'create-member'}
                    error={type === 'view-detail' && !status && !status?.label ? true : false}
                  >
                    {this.handleDropDownItems('memberStatus', this[`memberStatus${index !== undefined ? index : ''}`])}
                  </Dropdown>
                  <div className="text-error">
                    {type === 'view-detail' && !status && !status?.label ? '*กรุณากรอกข้อมูล' : null}
                  </div>
                </div>
              </div>
            )
          }
        </>
      );
    } catch (error) {
      return null;
    }
  }

  handleModalHeader = isModalType => {
    try {
      const { modal } = this.state;
      const { type, getMembershipDetail } = this.props;
      const check = isModalType ? type : modal;

      switch (check) {
        case 'remove-member':
          return null;
        case 'view-detail':
          return `Member ref. ${tenantMemberRefNo(getMembershipDetail)}`;
        case 'create-member':
          return 'สร้าง Member';
        default:
          return null;
      }
    } catch (error) {
      return null;
    }
  }

  handleConfirmModal = async () => {
    const { type, getMembershipDetail } = this.props;
    const { modal, memberVehicles, activeVehicleIndex, memberEndDate, confirmSelectVehicleIndex } = this.state;
    let newMemberEndDate, newMemberVehicles;

    switch (modal) {
      case 'confirm-change-member-status-to-inactive':
        if (type === 'view-detail') {
          const newMemberVehicle = getMembershipDetail.tenantMemberVehicles.length !== memberVehicles ? this.handlePrepareVehicleDetail() : memberVehicles;

          newMemberVehicle.forEach(ele => { // NOTE. update all vehicle status to inactive and set updatedAt
            if (ele.vehicleStatus.value === commonConstant.vehicleStatusActive) {
              ele.vehicleStatus = commonConstant.status[1];
              ele.detail.updatedAt = new Date();
            }
          });

          this.setState({ 'memberVehicles': newMemberVehicle, 'modal': null });
        }

        await this.setState({ 'memberStatus': commonConstant.status[1] }); // NOTE. change member status to inactive
        return this.handleDisableBtn();
      case 'confirm-change-member-status-to-active':
        newMemberEndDate = memberEndDate;

        if (new Date(memberEndDate).getTime() < new Date().getTime()) {
          newMemberEndDate = null;
        }

        await this.setState({ // NOTE. change member status to active and reset end date if end date < current date show
          'memberStatus': commonConstant.status[0],
          'memberEndDate': newMemberEndDate,
          'modal': null,
          'canChangeVehicle': true,
          'newVehicleIndex': null,
        });
        return this.handleDisableBtn();
      case 'confirm-change-vehicle-status':
        if (type === 'view-detail') {
          memberVehicles[activeVehicleIndex].vehicleStatus = commonConstant.status[0]; // NOTE. set selected vehicle to status active
          memberVehicles[activeVehicleIndex].detail.updatedAt = new Date();
        }

        await this.setState({ memberVehicles, 'modal': null });
        return this.handleDisableBtn();
      case 'confirm-select-vehicle':
        newMemberVehicles = memberVehicles.slice(0, -1);
        newMemberVehicles[confirmSelectVehicleIndex].vehicleStatus = commonConstant.status[0];

        await this.setState({
          'modal': null,
          'activeVehicleIndex': confirmSelectVehicleIndex,
          'confirmSelectVehicleIndex': null,
          'memberVehicles': newMemberVehicles,
          'canChangeVehicle': true,
          'newVehicleIndex': null,
        });
        return this.handleDisableBtn();
      default:
        return null;
    }
  }

  handleModalBody = () => {
    try {
      const { modal, confirmSelectVehicleIndex, memberVehicles } = this.state;

      switch (modal) {
        case 'confirm-cancel':
          return (
            <>
              <div className="title-warning">
                คุณยังไม่ได้บันทึกการเปลี่ยนแปลงข้อมูล ยืนยันปิดหน้าต่างโดยไม่บันทึกข้อมูลหรือไม่
              </div>
              <div className="box-btn center">
                <Button className="btn-sixtary btn-confirm" id="btn-confirm-cancel" onClick={() => this.handleShowModal(null, true)}>
                  ยืนยัน
                </Button>
                <Button className="btn-primary btn-back" id="btn-back" onClick={() => this.handleShowModal(null)}>
                  กลับ
                </Button>
              </div>
            </>
          );
        case 'confirm-change-member-status-to-inactive':
          return (
            <>
              <div className="title-warning">
                คุณต้องการยืนยันเปลี่ยนสถานะสมาชิกหรือไม่?
              </div>
              <div className="description-warning">
                <div>หากต้องการเปลี่ยนสถานะสมาชิกเป็น Inactive</div>
                <div>คุณจะไม่สารมารถเพิ่มหรือแก้ไขรายละเอียดรถได้</div>
                <div>และรถทุกคันจะถูกเปลี่ยนสถานะเป็น inactive อัตโนมัติ</div>
              </div>
              <div className="box-btn center">
                <Button className="btn-sixtary btn-confirm" id="btn-confirm-cancel" onClick={() => this.handleShowModal(null)}>
                  ยกเลิก
                </Button>
                <Button className="btn-primary btn-back" id="btn-confirm-change" onClick={this.handleConfirmModal}>
                  ยืนยัน
                </Button>
              </div>
            </>
          );
        case 'confirm-change-member-status-to-active':
          return (
            <>
              <div className="title-warning">
                คุณต้องการยืนยันเปลี่ยนสถานะสมาชิกหรือไม่?
              </div>
              <div className="description-warning">
                <div>ต้องการเปลี่ยนสถานะสมาชิกเป็น Active</div>
                <div>กรุณาเลือกรถที่ต้องการ Active จำนวน 1 คัน</div>
              </div>
              <div className="box-btn center">
                <Button className="btn-sixtary btn-confirm" id="btn-confirm-cancel" onClick={() => this.handleShowModal(null)}>
                  ยกเลิก
                </Button>
                <Button className="btn-primary btn-back" id="btn-confirm-change" onClick={this.handleConfirmModal}>
                  ยืนยัน
                </Button>
              </div>
            </>
          );
        case 'confirm-change-vehicle-status':
          return (
            <>
              <div className="title-warning">
                คุณต้องการยืนยันเปลี่ยนสถานะรถหรือไม่?
              </div>
              <div className="description-warning">
                <div>หากมีรถยนต์ที่มีสถานะ Active จอดอยู่ในโซน Member</div>
                <b>สมาชิกจะไม่สามารถนำรถคันอื่นมาจอดได้อีก</b>
                <div>แต่สมาชิกยังสามารถจอดในโซนของ Visitor ได้</div>
              </div>
              <div className="box-btn center">
                <Button className="btn-sixtary btn-confirm" id="btn-confirm-cancel" onClick={() => this.handleShowModal(null)}>
                  ยกเลิก
                </Button>
                <Button className="btn-primary btn-back" id="btn-confirm-change" onClick={this.handleConfirmModal}>
                  ยืนยัน
                </Button>
              </div>
            </>
          );
        case 'confirm-select-vehicle':
          return (
            <>
              <div className="title-warning">
                คุณได้เพิ่มป้ายทะเบียน {memberVehicles[confirmSelectVehicleIndex].vehicleLicensePlate} แล้วในระบบต้องการเปลี่ยนสถานะรถเป็น active หรือไม่
              </div>
              <div className="box-btn center">
                <Button className="btn-sixtary btn-confirm" id="btn-confirm-cancel" onClick={() => this.handleShowModal(null)}>
                  ยกเลิก
                </Button>
                <Button className="btn-primary btn-back" id="btn-confirm-change" onClick={this.handleConfirmModal}>
                  ยืนยัน
                </Button>
              </div>
            </>
          );
        default:
          return null;
      }
    } catch (error) {
      return null;
    }
  }

  handleVehicles = () => {
    try {
      const { activeVehicleIndex, memberVehicles, newVehicleIndex, memberStatus, deleteVehicleId } = this.state;
      const { type } = this.props;

      if (!memberVehicles) {
        return null;
      }               

      return memberVehicles.map((ele, index) => (        
        !deleteVehicleId.includes(ele.vehicleID) ? <div className="box-vehicle-item" key={randomNumber()}>
          <div
            className={`box-vehicle-status${(type === 'create-member') || (ele.vehicleStatus && ele.vehicleStatus.value === 'ACTIVE') ? ' active' : ''}${type === 'view-detail' && memberStatus?.value === commonConstant.memberStatusActive && !ele.vehicleProvince && !ele.vehicleProvince?.label && newVehicleIndex !== index ? ' border-error' : ''}`}
            onClick={() => this.handleValue('activeVehicleIndex', activeVehicleIndex === index ? null : index)}
          >
            <span className="left">
              {
                type === 'view-detail' && newVehicleIndex !== index ?
                  <>
                    <IconVehicle className="icon" name={vehicleTypeIconName(ele.vehicleType?.value)} />
                    <span id={`item-vehicle-plate-${index}`}>{ele.vehicleLicensePlate}</span>
                    <span id={`item-vehicleProvince-${index}`} className={!ele.vehicleProvince && !ele.vehicleProvince?.label && newVehicleIndex !== index ? 'text-error' : ''}>
                      {
                        (ele.vehicleProvince ? ele.vehicleProvince?.label ? ele.vehicleProvince?.label : ele.vehicleProvince : null) ||
                      (type === 'view-detail' && memberStatus?.value === commonConstant.memberStatusActive && !ele.vehicleProvince && !ele.vehicleProvince?.label && '*กรุณากรอกข้อมูลเพิ่มเติม')
                      }
                    </span>
                  </>
                  : <span id={`item-vehicle-${index}`}>
                    {type === 'view-detail' && newVehicleIndex === index ? 'กรุณากรอกข้อมูลรถคันใหม่' : `รถคันที่ ${index + 1}`}
                  </span>
              }
            </span>
            <span className="right">
              {ele.vehicleStatus.value === commonConstant.vehicleStatusInActive && <span>Inactive Date : {dateDDMMYYYYFormat(ele.detail.updatedAt)}</span>}
              <span className={`icon fas fa-chevron-${activeVehicleIndex === index ? 'up' : 'down'}`} />
            </span>
          </div>
          <div className={`box-detail${activeVehicleIndex === index ? ' active' : ''}`}>
            {this.handleVehicleDetail(index, ele)}
          </div>
        </div> : null
      ));
    } catch (error) {
      return null;
    }
  }

  handleChangeVehicle = () => {
    const { memberVehicles, memberStatus } = this.state;

    memberVehicles.push({
      'vehicleType': null,
      'vehicleLicensePlate': '',
      'vehicleProvince': null,
      'vehicleBrand': null,
      'vehicleColor': '',
      'activeVehicleLicensePlate': false,
      'vehicleID': null,
      'vehicleStatus': commonConstant.status[memberStatus.value === commonConstant.memberStatusInActive ? 1 : 0],
      'detail': {
        'updatedAt': memberStatus.value === commonConstant.memberStatusInActive ? new Date() : null,
      },
    });

    this.setState({
      'activeVehicleIndex': memberVehicles.length - 1,
      'canChangeVehicle': false,
      'newVehicleIndex': memberVehicles.length - 1,
      memberVehicles,
    });

    this.handleDisableBtn();
  }

  handleSaveDetail = () => {
    try {
      const { getMembershipDetail } = this.props;
      const {
        memberVehicles,
        memberPackage,
        companyName,
        tenantRefNo,
        firstName,
        lastName,
        identificationNo,
        phoneNo,
        lineId,
        email,
        memberStartDate,
        memberEndDate,
        memberNote,
        memberStatus,
        disabledBtnUpdateMember,
        deleteVehicleId,
      } = this.state;

      if (disabledBtnUpdateMember) {
        return null;
      }

      const objDataChange = {};
      const freeze = this.handlePrepareMemberDetail();
      const inputValue = {
        memberPackage,
        companyName,
        tenantRefNo,
        firstName,
        lastName,
        identificationNo,
        phoneNo,
        lineId,
        email,
        memberStartDate,
        memberEndDate,
        memberNote,
        memberStatus,
      };

      if (JSON.stringify(inputValue) !== JSON.stringify(freeze)) { // compare member detail is not match
        if (inputValue.memberPackage.buildingMembershipPackageID !== freeze.memberPackage.buildingMembershipPackageID) {
          objDataChange.buildingMembershipPackageID = inputValue.memberPackage.buildingMembershipPackageID;
        }
        if (inputValue.companyName.tenantID !== freeze.companyName.tenantID) {
          objDataChange.tenantID = inputValue.companyName.tenantID;
        }
        if (inputValue.email !== freeze.email) {
          objDataChange.tenantMemberEmail = inputValue.email;
        }
        if (new Date(inputValue.memberEndDate).getTime() !== new Date(freeze.memberEndDate).getTime()) {
          objDataChange.tenantMemberExpiredAt = dateYYYYMMDD(inputValue.memberEndDate);
        }
        if (inputValue.firstName !== freeze.firstName || inputValue.lastName !== freeze.lastName) {
          objDataChange.tenantMemberFirstName = inputValue.firstName;
          objDataChange.tenantMemberLastName = inputValue.lastName;
        }
        if (inputValue.identificationNo !== freeze.identificationNo) {
          objDataChange.tenantMemberIDCard = inputValue.identificationNo;
        }
        if (inputValue.lineId !== freeze.lineId) {
          objDataChange.tenantMemberLineID = inputValue.lineId;
        }
        if (inputValue.memberStatus.value !== freeze.memberStatus.value) {
          objDataChange.tenantMemberMembershipStatus = inputValue.memberStatus.value;
        }
        if (inputValue.memberNote !== freeze.memberNote) {
          objDataChange.tenantMemberRemark = inputValue.memberNote;
        }
        if (inputValue.phoneNo !== freeze.phoneNo) {
          objDataChange.tenantMemberTelephoneNo = inputValue.phoneNo;
        }
      }
      if (JSON.stringify(memberVehicles) !== JSON.stringify(this.handlePrepareVehicleDetail(true))) { // compare member vehicle is not match
        if (memberVehicles.length === getMembershipDetail.tenantMemberVehicles.length) { // if not add vehicle
          objDataChange.currentTenantMemberVehicles = this.handlePrePareVehicleDataToAPI(memberVehicles);
        } else {
          const currentVehicle = memberVehicles.slice(0, -1);
          const newVehicle = memberVehicles.slice(-1);

          objDataChange.currentTenantMemberVehicles = this.handlePrePareVehicleDataToAPI(currentVehicle);
          objDataChange.newTenantMemberVehicles = this.handlePrePareVehicleDataToAPI(newVehicle);
        }
      }
      if (deleteVehicleId.length > 0) {        
        objDataChange.deleteTenantMemberVehicles = this.handlePrepareDeleteVehicleDataToAPI(deleteVehicleId, getMembershipDetail.tenantMember.tenantMemberID);
      }

      this.setState({ 'loading': true });
      return this.props.dispatch(fetchUpdateMembership(getMembershipDetail.tenantMember.tenantMemberID, objDataChange));
    } catch (error) {
      return null;
    }
  }

  handleErrorValue = () => {
    const { errorValue } = this.state;
    // TODO: ไม่สามารถเพิ่มรถได้เนื่องจากสิทธิ์เต็ม กรุณาเพิ่ม Package
    switch (errorValue) {
      case 'dont-have-vehicle-active':
        return <div id="error-add-vehicle" className="error-add-vehicle">**กรุณาเลือกรถที่ต้องการ Active จำนวน 1 คัน**</div>;
      default:
        return null;
    }
  }

  handleType = () => {
    try {
      const { type } = this.props;
      const { disabledBtnCreateMember, loading, modal, canChangeVehicle, disabledBtnUpdateMember, memberStatus } = this.state;

      switch (type) {
        case 'create-member':
          return (
            <div className="MemberDetail">
              <div className="box">
                {loading ? <Loading /> : null}
                {this.handleMemberDetail()}
                {this.handleMembershipDetail()}
                <div className="title">
                  <span>ทะเบียนรถ</span>
                </div>
                {this.handleVehicles()}
                <div className="box-btn">
                  <Button className="btn-primary btn-save" id="btn-save" disabled={disabledBtnCreateMember} onClick={this.handleCreateMember}>
                    สร้าง member
                  </Button>
                </div>
              </div>
            </div>
          );
        case 'view-detail':
          return (
            <>
              <div className="MemberDetail">
                <div className="box">
                  {loading ? <Loading /> : null}
                  {this.handleMemberDetail()}
                  {this.handleMembershipDetail()}
                  <div className="title">
                    <span>ทะเบียนรถ</span>
                    {
                      canChangeVehicle && memberStatus.value === commonConstant.memberStatusActive && (
                        <span
                          className="box-btn"
                          id="btn-add-vehicle"
                          onClick={this.handleChangeVehicle}
                        >
                          <span className="icon icon-add" />
                          <span className="text">เพิ่มรถ</span>
                        </span>
                      )
                    }
                  </div>
                  {this.handleVehicles()}
                  {this.handleErrorValue()}
                  <div className="box-btn flex">
                    <Button
                      className="btn-save btn-primary"
                      id="btn-save"
                      onClick={this.handleSaveDetail}
                      disabled={disabledBtnUpdateMember}
                    >
                      บันทึก
                    </Button>
                  </div>
                </div>
              </div>
              <Modal
                show={modal ? true : false}
                header={this.handleModalHeader()}
                headerTemplate="a"
                handleToggle={this.handleShowModal}
              >
                <div className="MemberDetail">
                  <div className="box">
                    {this.handleModalBody()}
                  </div>
                </div>
              </Modal>
            </>
          );
        default:
          return null;
      }
    } catch (error) {
      return null;
    }
  }

  render() {
    const { type } = this.props;
    const { mainModal } = this.state;

    return (
      <Modal
        show={mainModal}
        header={this.handleModalHeader(true)}
        headerTemplate="a"
        handleToggle={() => {
          if (type === 'create-member') {
            return this.props.handleCloseDetail();
          }
          return this.handleShowModal(true);
        }}
        disableRemoveClass={type === 'view-detail' && this.handleCheckChangeDetail()}
      >
        <div className="MemberDetail">
          <div className="box">
            {this.handleType()}
          </div>
        </div>
      </Modal>
    );
  }
}

MemberDetail.propTypes = {
  'dispatch': PropTypes.func.isRequired,
  'match': PropTypes.shape({
    'params': PropTypes.shape({
      'buildingID': PropTypes.string,
    }),
  }),
  'type': PropTypes.string.isRequired,
  'handleClearState': PropTypes.func,
  'handleCloseDetail': PropTypes.func,
  'handleSetToast': PropTypes.func,
  'getMembershipPackage': PropTypes.shape({
    'data': PropTypes.array,
  }),
  'getCompany': PropTypes.shape({
    'data': PropTypes.array,
  }),
  'createMembership': PropTypes.shape({
    'data': PropTypes.array,
    'status': PropTypes.any,
    'errorMessage': PropTypes.string,
  }),
  'updateMembership': PropTypes.shape({
    'data': PropTypes.shape({}),
    'status': PropTypes.any,
    'errorMessage': PropTypes.string,
  }),
  'getMembershipDetail': PropTypes.shape({
    'customer': PropTypes.shape({
      'customerInfo': PropTypes.shape({
        'name': PropTypes.string,
        'firstName': PropTypes.string,
        'lastName': PropTypes.string,
      }),
    }),
    'buildingMembershipPackage': PropTypes.shape({
      'buildingMembershipPackageRemark': PropTypes.string,
      'buildingMembershipPackageID': PropTypes.string,
    }),
    'tenant': PropTypes.shape({
      'tenantName': PropTypes.string,
      'tenantID': PropTypes.string,
      'tenantRefNo': PropTypes.string,
    }),
    'tenantMember': PropTypes.shape({
      'tenantMemberInfo': PropTypes.shape({
        'remark': PropTypes.string,
        'deletedAt': PropTypes.string,
      }),
      'tenantMemberID': PropTypes.string,
      'tenantMemberStartedAt': PropTypes.string,
      'tenantMemberExpiredAt': PropTypes.string,
      'deletedAt': PropTypes.string,
    }),
    'tenantMemberVehicles': PropTypes.array,
    'tenantMemberBuildingMembershipPackages': PropTypes.array,
  }),
  'searchVehicleLicensePlate': PropTypes.shape({
    'data': PropTypes.array,
  }),
};

const mapStateToProps = ({
  getMembershipPackage,
  getCompany,
  searchVehicleLicensePlate,
  createMembership,
  getMembershipDetail,
  updateMembership,
}) => ({
  getMembershipPackage,
  getCompany,
  searchVehicleLicensePlate,
  createMembership,
  'getMembershipDetail': getMembershipDetail.data,
  updateMembership,
});

export default connect(mapStateToProps)(withRouter(MemberDetail));
